
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "AppearanceCheck",
        setup() {
            let state: State = reactive({
                titleText: '外观检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【外观检测标准】检测项目中如出现剐蹭、划痕、变形、锈蚀、破损、更换、缝隙不均、拆卸未换、钣金修复、雹子坑、腻子开裂、喷漆瑕疵、老化、胶体异常、掉（爆）漆、色差、重做漆、脏污、胶体开裂、封边不整、缺失、改装、故障、磨损、碎点、进水、撕裂等缺陷状况，根据《268V检测认证标准》综合判断为外观缺陷。',
                        'prop_up_height',
                        '【受限不可检】检测过程中，受环境、车主授权等不可抗原因导致无法检测，268V不对受限不可检的检测项产生的任何疑问负责。'
                    ]
                },
                defectList: [],
                listName: '外观检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {appearance} = data;
                if (appearance) {
                    const {importantItemCount, defectItemCount, itemCount, itemList, itemTitle} = appearance
                    state.defectList = itemList
                    state.listName = itemTitle
                    state.listDefectNumber = defectItemCount
                    state.importantNumber = importantItemCount
                    state.listSumNumber = itemCount
                }
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
